/**
 * Build-time configuration for the preview placeholder.
 *
 * Everything here is public. Nothing secret may be added to this file or to any `VITE_*`
 * variable — Vite inlines them into the shipped bundle. See docs/SECURITY.md.
 */

export interface AppConfig {
  /** Base URL of the Dubbed clinic API, or null when the API is not deployed yet. */
  readonly apiBaseUrl: string | null;
  /** Short git SHA of the build, when CI provides one. */
  readonly commit: string;
  /** ISO timestamp of the build. */
  readonly builtAt: string;
  /** Deployment lane. Only ever `preview` while the holds in docs/HOLDS.md are in force. */
  readonly environment: 'local' | 'preview';
}

function readOptional(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export const config: AppConfig = {
  apiBaseUrl: readOptional(import.meta.env.VITE_DUBBED_API_BASE_URL),
  commit: readOptional(import.meta.env.VITE_DUBBED_COMMIT) ?? 'local',
  builtAt: readOptional(import.meta.env.VITE_DUBBED_BUILT_AT) ?? new Date().toISOString(),
  environment: import.meta.env.DEV ? 'local' : 'preview',
};

/**
 * Resources that already exist in AWS account 149536453165. Mirrored from
 * iac/lib/existing-resources.ts so the preview page can show what it is running on.
 */
export const previewInfrastructure = {
  account: '149536453165',
  region: 'us-east-1',
  originBucket: 'dubbed-preview-origin-149536453165',
  distributionId: 'E2BHV36GLUMKP3',
  distributionUrl: 'https://dv22edowaxda.cloudfront.net',
} as const;
